import Vue from 'vue'
import Vuex from 'vuex'
import UserService from "@/services/UserService";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        user: null
    },
    getters: {
        user: state => {
            return state.user;
        }
    },
    mutations: {
        authUser(state, userData) {
            state.user = userData;
        }
    },
    actions: {
        login({commit}, paylod) {

            UserService.getUser(paylod.account.userName)
                .then(p => {
                    commit('authUser', {
                        id: p.id,
                        accessToken: paylod.accessToken,
                        name: p.name,
                        roles: p.roles
                    })
                })

            // TODO: Be able to handle unauthorized / inactive users somewhere, similar to error component
        }
    },
    modules: {}
})
